// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1JVc-","top":"styles_top__1Q-JI","left":"styles_left__2u6xA","description":"styles_description__3rZA7"};